import * as React from 'react'
import { useLocation } from 'react-router-dom';
import ADUH001 from './aduh001.mp3';
import ADUH002 from './aduh002.mp3';
import ADUH003 from './aduh003.mp3';

const soundFiles = [ADUH001, ADUH002, ADUH003];

function SoundOnClick() {
  const location = useLocation();

  // Preload audio files into Audio objects
  const audioObjects = React.useMemo(() => {
    return soundFiles.map(src => {
      const audio = new Audio(src);
      audio.preload = 'auto'; // Encourage preloading
      return audio;
    });
  }, []);

  React.useEffect(() => {
    // Check if the current path starts with /aduh
    if (location.pathname.startsWith('/aduh')) {
      const playRandomSound = () => {
        const randomIndex = Math.floor(Math.random() * soundFiles.length);
        const audio = audioObjects[randomIndex];
        audio.currentTime = 0; // Reset to start for replay
        audio.play().catch(error => console.error('Audio playback failed:', error));
      };

      // Add click event listener to the document
      document.addEventListener('mousedown', playRandomSound);

      // Cleanup: remove event listener on component unmount
      return () => {
        document.removeEventListener('mousedown', playRandomSound);
      };
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
}

export default SoundOnClick;